import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Text } from '@/components/ui/text';
import { type FC } from 'react';

export const PromptWarningModal: FC<{
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  isLoading: boolean;
  onConfirm: () => void;
}> = ({ isOpen, onOpenChange, isLoading, onConfirm }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="pr-1">
            Are you sure you want to regenerate your extraction fields?
          </DialogTitle>
        </DialogHeader>
        <Text>
          This will overwrite your existing extraction fields and permanently
          delete all current extraction results.
        </Text>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button variant="destructive" onClick={onConfirm} loading={isLoading}>
            Yes, regenerate fields
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
